unit unit_ListeTickets;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, XData.Web.Client,
  WEBLib.WebCtrls, strutils;

type
  TListeTickets = class(TForm)
    xdsTickets: TXDataWebDataSet;
    Container3: THTMLContainer;
    Container2: THTMLContainer;
    Container1: THTMLContainer;
    ResultLabel: TLabel;
    btnzurueck: TButton;
    xdsTicketsID: TIntegerField;
    xdsTicketsErstelltAm: TDateTimeField;
    xdsTicketsBetreff: TStringField;
    xdsTicketsBeschreibung: TStringField;
    xdsTicketsKundennummerKundennummer: TStringField;
    xdsTicketsKundennummerNachname: TStringField;
    xdsTicketsNachname: TStringField;
    xdsTicketsVorname: TStringField;
    xdsTicketsStatus: TXDataWebEntityField;
    xdsTicketsStatusStatus: TStringField;
    xdsTicketsPrioritaet: TXDataWebEntityField;
    xdsTicketsPrioritaetPrioritaet: TIntegerField;
    xdsTicketsPrioritaetPrioText: TStringField;
    xdsTicketsPrioritaetPrioFarbe: TIntegerField;
    xdsTicketsAbrechnungsbetrag: TFloatField;
    xdsTicketsAbrechnungRechnungsnummer: TStringField;
    xdsTicketsAberechnetAm: TDateTimeField;
    xdsTicketsErledigtAm: TDateTimeField;
    xdsTicketsEmail: TStringField;
    xdsTicketsSystemInfo: TStringField;
    xdsTicketsLoesung: TStringField;
    xdsTicketsProtokoll: TStringField;
    xdsTicketsZeitaufwandMinuten: TIntegerField;
    xdsTicketsAbzurechnendeMinuten: TIntegerField;
    xdsTicketsAbgerechneteMinuten: TIntegerField;
    xdsTicketsBenachrichtigungNEU: TDateTimeField;
    xdsTicketsBenachrichtigungLoesung: TDateTimeField;
    xdsTicketsInterneBemerkung: TStringField;
    xdsTicketsLoesungInfoSenden: TIntegerField;
    xdsTicketsKontaktperson: TStringField;
    xdsTicketsErreichbarkeitTelefon: TStringField;
    xdsTicketsErreichbarkeitWann: TStringField;
    xdsTicketsKategorie: TXDataWebEntityField;
    xdsTicketsKategorieKategorie: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsTicketsAfterOpen(DataSet: TDataSet);
    procedure ResultLabelClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure WebFormHashChange(Sender: TObject; oldURL, newURL: string);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    EinzelCard:THTMLDiv;
    procedure EinzelCardclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  ListeTickets: TListeTickets;

implementation
  uses unit1, unit2, unit_EinzelTicket;
{$R *.dfm}


procedure TListeTickets.EinzelCardclick(Sender:TObject);
var
  EinzelTicket:TEinzelTicket;
  MyMerkerTicket:string;
begin
  myMerkerTicket:=(sender as THTMLDiv).ElementID;
  Container3.HTML.text:='';
  EinzelTicket := TEinzelTicket.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelTicket).MerkerTicket:=myMerkerTicket;
    end
    );

  EinzelTicket.ShowModal(procedure(AValue: TModalResult)
    begin
      xdsTickets.close;
      xdsTickets.Load;
    end
    );
end;






procedure TListeTickets.ResultLabelClick(Sender: TObject);
begin
  if Pos('mehr anzeigen',resultlabel.html,0)>1 then
  begin
    xdstickets.Close;
    xdstickets.querystring:='$expand=Kundennummer,Status,Kategorie&$filter=(Status  ne '+quotedstr('abgeschlossen')+') &$orderby=ID DESC';
    xdstickets.Load;
  end;
end;

procedure TListeTickets.btnzurueckClick(Sender: TObject);
begin
  xdsTickets.Close;
  self.close;
end;

procedure TListeTickets.WebFormHashChange(Sender: TObject; oldURL,
  newURL: string);
begin
  if window.location.hash = '' then btnzurueckClick(sender);
end;

procedure TListeTickets.WebFormShow(Sender: TObject);
begin
  xdstickets.Close;
  xdstickets.querystring:='$expand=Kundennummer,Status,Kategorie&$filter=(Status  ne '+quotedstr('abgeschlossen')+') &$orderby=ID DESC';
  xdstickets.Load;
end;

procedure TListeTickets.xdsTicketsAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Tickets offen</h5></nav>';
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  ResultLabel.ParentElement:=myelement;
  xdsTickets.First;
  if xdsTickets.RecordCount=0 then ResultLabel.HTML:='nichts gefunden';
  if xdsTickets.RecordCount>0 then ResultLabel.HTML:='Ticket(s): '+inttostr(xdsTickets.RecordCount);
  if xdsTickets.RecordCount>99 then ResultLabel.HTML:='mehr als 100 Tickets <I><U>mehr anzeigen</I></U>';
  if xdsTickets.RecordCount>100 then ResultLabel.HTML:='Tickets: '+inttostr(xdsTickets.RecordCount)+' (max. Anzeige: 500)';


  while not xdsTickets.eof do
  begin

    Einzelkarte:='<div class="card-header"><h5>'+xdsTicketsID.asstring+' | '+formatdatetime('DD.MM.YYYY hh:mm',xdsTicketsErstelltAm.AsDateTime)+'</h5><i>'+xdsTicketsKundennummerKundennummer.AsString+' | '+xdsTicketsNachname.asstring+'</i></div>';
    Einzelkarte:=Einzelkarte+'<div class="card-body "><b>'+xdsTicketsBetreff.AsString+'</b><br>';
    Einzelkarte:=Einzelkarte+leftstr(xdsTicketsBeschreibung.AsString,80)+'...<br>';
    Einzelkarte:=Einzelkarte+'<i><b>'+xdsTicketsStatusStatus.AsString+'</b></i><br>';
    if xdsTicketsKategorieKategorie.asstring<>'[-]' then Einzelkarte:=Einzelkarte+'<i><b>'+xdsTicketsKategorieKategorie.AsString+'</b></i><br>';
    if xdsTicketsInterneBemerkung.asstring<>'' then Einzelkarte:=Einzelkarte+'<i>'+xdsTicketsInterneBemerkung.asstring+'</i><br>';
    Einzelkarte:=Einzelkarte+'</div>';

    myelement:=Container3.ElementHandle;
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:=xdsTicketsID.asstring;
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.Width:=350;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card m-1 border-info';
    EinzelCard.OnClick:=@EinzelCardClick;
    EinzelCard.ParentElement:=myelement;

    xdsTickets.Next;
  end;

end;

procedure TListeTickets.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  xdsTickets := TXDataWebDataSet.Create(Self);
  xdsTicketsID := TIntegerField.Create(Self);
  xdsTicketsErstelltAm := TDateTimeField.Create(Self);
  xdsTicketsBetreff := TStringField.Create(Self);
  xdsTicketsBeschreibung := TStringField.Create(Self);
  xdsTicketsKundennummerKundennummer := TStringField.Create(Self);
  xdsTicketsKundennummerNachname := TStringField.Create(Self);
  xdsTicketsNachname := TStringField.Create(Self);
  xdsTicketsVorname := TStringField.Create(Self);
  xdsTicketsStatus := TXDataWebEntityField.Create(Self);
  xdsTicketsStatusStatus := TStringField.Create(Self);
  xdsTicketsPrioritaet := TXDataWebEntityField.Create(Self);
  xdsTicketsPrioritaetPrioritaet := TIntegerField.Create(Self);
  xdsTicketsPrioritaetPrioText := TStringField.Create(Self);
  xdsTicketsPrioritaetPrioFarbe := TIntegerField.Create(Self);
  xdsTicketsAbrechnungsbetrag := TFloatField.Create(Self);
  xdsTicketsAbrechnungRechnungsnummer := TStringField.Create(Self);
  xdsTicketsAberechnetAm := TDateTimeField.Create(Self);
  xdsTicketsErledigtAm := TDateTimeField.Create(Self);
  xdsTicketsEmail := TStringField.Create(Self);
  xdsTicketsSystemInfo := TStringField.Create(Self);
  xdsTicketsLoesung := TStringField.Create(Self);
  xdsTicketsProtokoll := TStringField.Create(Self);
  xdsTicketsZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsTicketsAbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsTicketsAbgerechneteMinuten := TIntegerField.Create(Self);
  xdsTicketsBenachrichtigungNEU := TDateTimeField.Create(Self);
  xdsTicketsBenachrichtigungLoesung := TDateTimeField.Create(Self);
  xdsTicketsInterneBemerkung := TStringField.Create(Self);
  xdsTicketsLoesungInfoSenden := TIntegerField.Create(Self);
  xdsTicketsKontaktperson := TStringField.Create(Self);
  xdsTicketsErreichbarkeitTelefon := TStringField.Create(Self);
  xdsTicketsErreichbarkeitWann := TStringField.Create(Self);
  xdsTicketsKategorie := TXDataWebEntityField.Create(Self);
  xdsTicketsKategorieKategorie := TStringField.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  xdsTickets.BeforeLoadDFMValues;
  xdsTicketsID.BeforeLoadDFMValues;
  xdsTicketsErstelltAm.BeforeLoadDFMValues;
  xdsTicketsBetreff.BeforeLoadDFMValues;
  xdsTicketsBeschreibung.BeforeLoadDFMValues;
  xdsTicketsKundennummerKundennummer.BeforeLoadDFMValues;
  xdsTicketsKundennummerNachname.BeforeLoadDFMValues;
  xdsTicketsNachname.BeforeLoadDFMValues;
  xdsTicketsVorname.BeforeLoadDFMValues;
  xdsTicketsStatus.BeforeLoadDFMValues;
  xdsTicketsStatusStatus.BeforeLoadDFMValues;
  xdsTicketsPrioritaet.BeforeLoadDFMValues;
  xdsTicketsPrioritaetPrioritaet.BeforeLoadDFMValues;
  xdsTicketsPrioritaetPrioText.BeforeLoadDFMValues;
  xdsTicketsPrioritaetPrioFarbe.BeforeLoadDFMValues;
  xdsTicketsAbrechnungsbetrag.BeforeLoadDFMValues;
  xdsTicketsAbrechnungRechnungsnummer.BeforeLoadDFMValues;
  xdsTicketsAberechnetAm.BeforeLoadDFMValues;
  xdsTicketsErledigtAm.BeforeLoadDFMValues;
  xdsTicketsEmail.BeforeLoadDFMValues;
  xdsTicketsSystemInfo.BeforeLoadDFMValues;
  xdsTicketsLoesung.BeforeLoadDFMValues;
  xdsTicketsProtokoll.BeforeLoadDFMValues;
  xdsTicketsZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsTicketsAbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsTicketsAbgerechneteMinuten.BeforeLoadDFMValues;
  xdsTicketsBenachrichtigungNEU.BeforeLoadDFMValues;
  xdsTicketsBenachrichtigungLoesung.BeforeLoadDFMValues;
  xdsTicketsInterneBemerkung.BeforeLoadDFMValues;
  xdsTicketsLoesungInfoSenden.BeforeLoadDFMValues;
  xdsTicketsKontaktperson.BeforeLoadDFMValues;
  xdsTicketsErreichbarkeitTelefon.BeforeLoadDFMValues;
  xdsTicketsErreichbarkeitWann.BeforeLoadDFMValues;
  xdsTicketsKategorie.BeforeLoadDFMValues;
  xdsTicketsKategorieKategorie.BeforeLoadDFMValues;
  try
    Name := 'ListeTickets';
    Width := 224;
    Height := 319;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnHashChange', 'WebFormHashChange');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 8;
    ResultLabel.Top := 204;
    ResultLabel.Width := 55;
    ResultLabel.Height := 13;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-2';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssAuto;
    ResultLabel.WidthPercent := 100.000000000000000000;
    SetEvent(ResultLabel, Self, 'OnClick', 'ResultLabelClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 3;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 67;
    btnzurueck.Top := 141;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    xdsTickets.SetParentComponent(Self);
    xdsTickets.Name := 'xdsTickets';
    xdsTickets.AfterOpen := xdsTicketsAfterOpen;
    xdsTickets.EntitySetName := 'ITS_TicketMain';
    xdsTickets.Connection := DM2.XDataWebConnection1;
    xdsTickets.SubpropsDepth := 1;
    xdsTickets.QueryString := '$expand=Kundennummer,Status,Kategorie&$filter=(Status  ne '#39'abgeschlossen'#39')';
    xdsTickets.QueryTop := 100;
    xdsTickets.Left := 20;
    xdsTickets.Top := 142;
    xdsTicketsID.SetParentComponent(xdsTickets);
    xdsTicketsID.Name := 'xdsTicketsID';
    xdsTicketsID.FieldName := 'ID';
    xdsTicketsID.Required := True;
    xdsTicketsErstelltAm.SetParentComponent(xdsTickets);
    xdsTicketsErstelltAm.Name := 'xdsTicketsErstelltAm';
    xdsTicketsErstelltAm.FieldName := 'ErstelltAm';
    xdsTicketsBetreff.SetParentComponent(xdsTickets);
    xdsTicketsBetreff.Name := 'xdsTicketsBetreff';
    xdsTicketsBetreff.FieldName := 'Betreff';
    xdsTicketsBetreff.Size := 100;
    xdsTicketsBeschreibung.SetParentComponent(xdsTickets);
    xdsTicketsBeschreibung.Name := 'xdsTicketsBeschreibung';
    xdsTicketsBeschreibung.FieldName := 'Beschreibung';
    xdsTicketsBeschreibung.Size := 255;
    xdsTicketsKundennummerKundennummer.SetParentComponent(xdsTickets);
    xdsTicketsKundennummerKundennummer.Name := 'xdsTicketsKundennummerKundennummer';
    xdsTicketsKundennummerKundennummer.FieldName := 'Kundennummer.Kundennummer';
    xdsTicketsKundennummerKundennummer.Size := 13;
    xdsTicketsKundennummerNachname.SetParentComponent(xdsTickets);
    xdsTicketsKundennummerNachname.Name := 'xdsTicketsKundennummerNachname';
    xdsTicketsKundennummerNachname.FieldName := 'Kundennummer.Nachname';
    xdsTicketsKundennummerNachname.Size := 40;
    xdsTicketsNachname.SetParentComponent(xdsTickets);
    xdsTicketsNachname.Name := 'xdsTicketsNachname';
    xdsTicketsNachname.FieldName := 'Nachname';
    xdsTicketsNachname.Size := 40;
    xdsTicketsVorname.SetParentComponent(xdsTickets);
    xdsTicketsVorname.Name := 'xdsTicketsVorname';
    xdsTicketsVorname.FieldName := 'Vorname';
    xdsTicketsVorname.Size := 40;
    xdsTicketsStatus.SetParentComponent(xdsTickets);
    xdsTicketsStatus.Name := 'xdsTicketsStatus';
    xdsTicketsStatus.FieldName := 'Status';
    xdsTicketsStatusStatus.SetParentComponent(xdsTickets);
    xdsTicketsStatusStatus.Name := 'xdsTicketsStatusStatus';
    xdsTicketsStatusStatus.FieldName := 'Status.Status';
    xdsTicketsStatusStatus.Size := 25;
    xdsTicketsPrioritaet.SetParentComponent(xdsTickets);
    xdsTicketsPrioritaet.Name := 'xdsTicketsPrioritaet';
    xdsTicketsPrioritaet.FieldName := 'Prioritaet';
    xdsTicketsPrioritaetPrioritaet.SetParentComponent(xdsTickets);
    xdsTicketsPrioritaetPrioritaet.Name := 'xdsTicketsPrioritaetPrioritaet';
    xdsTicketsPrioritaetPrioritaet.FieldName := 'Prioritaet.Prioritaet';
    xdsTicketsPrioritaetPrioText.SetParentComponent(xdsTickets);
    xdsTicketsPrioritaetPrioText.Name := 'xdsTicketsPrioritaetPrioText';
    xdsTicketsPrioritaetPrioText.FieldName := 'Prioritaet.PrioText';
    xdsTicketsPrioritaetPrioFarbe.SetParentComponent(xdsTickets);
    xdsTicketsPrioritaetPrioFarbe.Name := 'xdsTicketsPrioritaetPrioFarbe';
    xdsTicketsPrioritaetPrioFarbe.FieldName := 'Prioritaet.PrioFarbe';
    xdsTicketsAbrechnungsbetrag.SetParentComponent(xdsTickets);
    xdsTicketsAbrechnungsbetrag.Name := 'xdsTicketsAbrechnungsbetrag';
    xdsTicketsAbrechnungsbetrag.FieldName := 'Abrechnungsbetrag';
    xdsTicketsAbrechnungRechnungsnummer.SetParentComponent(xdsTickets);
    xdsTicketsAbrechnungRechnungsnummer.Name := 'xdsTicketsAbrechnungRechnungsnummer';
    xdsTicketsAbrechnungRechnungsnummer.FieldName := 'AbrechnungRechnungsnummer';
    xdsTicketsAbrechnungRechnungsnummer.Size := 10;
    xdsTicketsAberechnetAm.SetParentComponent(xdsTickets);
    xdsTicketsAberechnetAm.Name := 'xdsTicketsAberechnetAm';
    xdsTicketsAberechnetAm.FieldName := 'AberechnetAm';
    xdsTicketsErledigtAm.SetParentComponent(xdsTickets);
    xdsTicketsErledigtAm.Name := 'xdsTicketsErledigtAm';
    xdsTicketsErledigtAm.FieldName := 'ErledigtAm';
    xdsTicketsEmail.SetParentComponent(xdsTickets);
    xdsTicketsEmail.Name := 'xdsTicketsEmail';
    xdsTicketsEmail.FieldName := 'Email';
    xdsTicketsEmail.Size := 50;
    xdsTicketsSystemInfo.SetParentComponent(xdsTickets);
    xdsTicketsSystemInfo.Name := 'xdsTicketsSystemInfo';
    xdsTicketsSystemInfo.FieldName := 'SystemInfo';
    xdsTicketsSystemInfo.Size := 255;
    xdsTicketsLoesung.SetParentComponent(xdsTickets);
    xdsTicketsLoesung.Name := 'xdsTicketsLoesung';
    xdsTicketsLoesung.FieldName := 'Loesung';
    xdsTicketsLoesung.Size := 255;
    xdsTicketsProtokoll.SetParentComponent(xdsTickets);
    xdsTicketsProtokoll.Name := 'xdsTicketsProtokoll';
    xdsTicketsProtokoll.FieldName := 'Protokoll';
    xdsTicketsProtokoll.Size := 255;
    xdsTicketsZeitaufwandMinuten.SetParentComponent(xdsTickets);
    xdsTicketsZeitaufwandMinuten.Name := 'xdsTicketsZeitaufwandMinuten';
    xdsTicketsZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsTicketsAbzurechnendeMinuten.SetParentComponent(xdsTickets);
    xdsTicketsAbzurechnendeMinuten.Name := 'xdsTicketsAbzurechnendeMinuten';
    xdsTicketsAbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsTicketsAbgerechneteMinuten.SetParentComponent(xdsTickets);
    xdsTicketsAbgerechneteMinuten.Name := 'xdsTicketsAbgerechneteMinuten';
    xdsTicketsAbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsTicketsBenachrichtigungNEU.SetParentComponent(xdsTickets);
    xdsTicketsBenachrichtigungNEU.Name := 'xdsTicketsBenachrichtigungNEU';
    xdsTicketsBenachrichtigungNEU.FieldName := 'BenachrichtigungNEU';
    xdsTicketsBenachrichtigungLoesung.SetParentComponent(xdsTickets);
    xdsTicketsBenachrichtigungLoesung.Name := 'xdsTicketsBenachrichtigungLoesung';
    xdsTicketsBenachrichtigungLoesung.FieldName := 'BenachrichtigungLoesung';
    xdsTicketsInterneBemerkung.SetParentComponent(xdsTickets);
    xdsTicketsInterneBemerkung.Name := 'xdsTicketsInterneBemerkung';
    xdsTicketsInterneBemerkung.FieldName := 'InterneBemerkung';
    xdsTicketsInterneBemerkung.Size := 255;
    xdsTicketsLoesungInfoSenden.SetParentComponent(xdsTickets);
    xdsTicketsLoesungInfoSenden.Name := 'xdsTicketsLoesungInfoSenden';
    xdsTicketsLoesungInfoSenden.FieldName := 'LoesungInfoSenden';
    xdsTicketsKontaktperson.SetParentComponent(xdsTickets);
    xdsTicketsKontaktperson.Name := 'xdsTicketsKontaktperson';
    xdsTicketsKontaktperson.FieldName := 'Kontaktperson';
    xdsTicketsKontaktperson.Size := 100;
    xdsTicketsErreichbarkeitTelefon.SetParentComponent(xdsTickets);
    xdsTicketsErreichbarkeitTelefon.Name := 'xdsTicketsErreichbarkeitTelefon';
    xdsTicketsErreichbarkeitTelefon.FieldName := 'ErreichbarkeitTelefon';
    xdsTicketsErreichbarkeitTelefon.Size := 100;
    xdsTicketsErreichbarkeitWann.SetParentComponent(xdsTickets);
    xdsTicketsErreichbarkeitWann.Name := 'xdsTicketsErreichbarkeitWann';
    xdsTicketsErreichbarkeitWann.FieldName := 'ErreichbarkeitWann';
    xdsTicketsErreichbarkeitWann.Size := 100;
    xdsTicketsKategorie.SetParentComponent(xdsTickets);
    xdsTicketsKategorie.Name := 'xdsTicketsKategorie';
    xdsTicketsKategorie.FieldName := 'Kategorie';
    xdsTicketsKategorieKategorie.SetParentComponent(xdsTickets);
    xdsTicketsKategorieKategorie.Name := 'xdsTicketsKategorieKategorie';
    xdsTicketsKategorieKategorie.FieldName := 'Kategorie.Kategorie';
    xdsTicketsKategorieKategorie.Size := 25;
  finally
    ResultLabel.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    xdsTickets.AfterLoadDFMValues;
    xdsTicketsID.AfterLoadDFMValues;
    xdsTicketsErstelltAm.AfterLoadDFMValues;
    xdsTicketsBetreff.AfterLoadDFMValues;
    xdsTicketsBeschreibung.AfterLoadDFMValues;
    xdsTicketsKundennummerKundennummer.AfterLoadDFMValues;
    xdsTicketsKundennummerNachname.AfterLoadDFMValues;
    xdsTicketsNachname.AfterLoadDFMValues;
    xdsTicketsVorname.AfterLoadDFMValues;
    xdsTicketsStatus.AfterLoadDFMValues;
    xdsTicketsStatusStatus.AfterLoadDFMValues;
    xdsTicketsPrioritaet.AfterLoadDFMValues;
    xdsTicketsPrioritaetPrioritaet.AfterLoadDFMValues;
    xdsTicketsPrioritaetPrioText.AfterLoadDFMValues;
    xdsTicketsPrioritaetPrioFarbe.AfterLoadDFMValues;
    xdsTicketsAbrechnungsbetrag.AfterLoadDFMValues;
    xdsTicketsAbrechnungRechnungsnummer.AfterLoadDFMValues;
    xdsTicketsAberechnetAm.AfterLoadDFMValues;
    xdsTicketsErledigtAm.AfterLoadDFMValues;
    xdsTicketsEmail.AfterLoadDFMValues;
    xdsTicketsSystemInfo.AfterLoadDFMValues;
    xdsTicketsLoesung.AfterLoadDFMValues;
    xdsTicketsProtokoll.AfterLoadDFMValues;
    xdsTicketsZeitaufwandMinuten.AfterLoadDFMValues;
    xdsTicketsAbzurechnendeMinuten.AfterLoadDFMValues;
    xdsTicketsAbgerechneteMinuten.AfterLoadDFMValues;
    xdsTicketsBenachrichtigungNEU.AfterLoadDFMValues;
    xdsTicketsBenachrichtigungLoesung.AfterLoadDFMValues;
    xdsTicketsInterneBemerkung.AfterLoadDFMValues;
    xdsTicketsLoesungInfoSenden.AfterLoadDFMValues;
    xdsTicketsKontaktperson.AfterLoadDFMValues;
    xdsTicketsErreichbarkeitTelefon.AfterLoadDFMValues;
    xdsTicketsErreichbarkeitWann.AfterLoadDFMValues;
    xdsTicketsKategorie.AfterLoadDFMValues;
    xdsTicketsKategorieKategorie.AfterLoadDFMValues;
  end;
end;

end.